import React, { Component } from 'react';
import './placeOrder.css'
import Header from '../../Header';
const url = "   https://bwapi.onrender.com/menuitems"

const pUrl = "https://bwapi.onrender.com/placeOrder"
class PlaceOrder extends Component {
    constructor(props) {
        super(props)
        let sessionData = sessionStorage.getItem('userInfo') ? sessionStorage.getItem('userInfo').split(',') : []

        this.state = {

            id: Math.floor(Math.random() * 10000),
            product_name: this.props.match.params.productName,
            name: sessionData?sessionData[0]:"",
            email: sessionData?sessionData[1]:"",
            cost: 0,
            phone: sessionData?sessionData[2]:"",
            address: '',
            Item: ''

        }

    }
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }
    checkout = () => {
        let obj = this.state
        obj.Item = sessionStorage.getItem('productItem')

        fetch(pUrl, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(obj)
        })
            // .then(this.props.history.push('/viewBooking'))
            .then(console.log('Order Added'))
    }

    renderItem = (data) => {
        if (data) {
            return data.map((item) => {
                return (
                    <div className="orderItems p-4 ms-1" key={item.id}>
                        <img className='prodimg' src={item.Image} alt={item.Brand} />
                        <h3 className='brandclr'>{item.Brand}</h3>
                        <h5>{item.product_name}</h5>
                        <h5>Rs. {item.Price}</h5>
                    </div>

                )
            })
        }
    }
    render() {
        return (
            <>
            <Header />
                <div className='container '>
                    <div className="card mb-3 w-75 width p-3" >

                        <form action="https://bwpayment.onrender.com/paynow" method='POST'>



                            <div className='heading '>
                                <input type="hidden" name="cost" value={this.state.cost} />
                                <input type="hidden" name="id" value={this.state.id} />
                                <input type="hidden" name="hotel_name" value={this.state.product_name} />
                                <h3 className=' p-2  animate-charcter'>{this.state.product_name}</h3>
                            </div>

                            <div class="row mb-4 ">

                                <div class="col">
                                    <div class="form-outline">
                                        <input for='fname' className="form-control" name="name" required value={this.state.name} onChange={this.handleChange} placeholder='abc'/>
                                        <label class="control-label" for="fname">First name</label>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="form-outline">
                                        <input for='email' className="form-control" name="email" required  value={this.state.email} onChange={this.handleChange} placeholder='abc@gmail.com' />
                                        <label class="control-label" for="fname">Email</label>
                                    </div>
                                </div>
                            </div>


                            <div class="col">
                                <div class="form-outline">
                                    <input for='phone' className="form-control" name="phone" required  value={this.state.phone} onChange={this.handleChange} placeholder='999999999'/>
                                    <label class="control-label" for="fname">Phone</label>
                                </div>
                            </div>

                            <div class="col">
                                <div class="form-outline">
                                    <input for='address' className="form-control" name="address" required value={this.state.address} onChange={this.handleChange} placeholder='abc nager, house no.-123, Near abc, Pincode- 999999'/>
                                    <label class="control-label" for="fname">Address</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h2>Total price is ₹ {this.state.cost}</h2>
                                </div>
                            </div>

                            <button class="btn btn-primary " onClick={this.checkout} type='submit'>
                                Place order
                            </button>
                        </form>
                        {this.renderItem(this.state.Item)}

                    </div>
                </div>

            </>
        )
    }
    componentDidMount() {
        let productItem = sessionStorage.getItem('productItem');
        let orderId = [];
        orderId.push(parseFloat(productItem))

        fetch(url, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json'
            },
            body: JSON.stringify(orderId)
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data)
                let totalPrice = 0;
                data.map((item) => {
                    totalPrice = totalPrice + parseFloat(item.Price);
                    return 'ok'
                })
                this.setState({ Item: data, cost: totalPrice })
            })
    }

}
export default PlaceOrder;